// Single source of truth for the mark — the shipping PandaTaps face, exactly.
// viewBox 0 0 200 200. Do not "improve" these numbers.
export const G = {
  viewBox: "0 0 200 200",
  face: { cx: 100, cy: 100, r: 85 },
  earL: { cx: 45, cy: 45, r: 23 },
  earR: { cx: 155, cy: 45, r: 23 },
  // Where each ear meets the face — rotation origin for twitch / greeting.
  earBaseL: [58, 62],
  earBaseR: [142, 62],
  patchL: { cx: 65, cy: 85, r: 25 },
  patchR: { cx: 135, cy: 85, r: 25 },
  eyeL: { cx: 65, cy: 85, r: 12 },
  eyeR: { cx: 135, cy: 85, r: 12 },
  pupilL: { cx: 65, cy: 85, r: 6 },
  pupilR: { cx: 135, cy: 85, r: 6 },
  blushL: { cx: 50, cy: 110, r: 10 },
  blushR: { cx: 150, cy: 110, r: 10 },
  blush: "#ff9999",
  blushOpacity: 0.3,
  nose: { cx: 100, cy: 115, rx: 13, ry: 9 },
  mouth: "M 85 125 Q 100 140 115 125",
  mouthStroke: 3,
  // Compact (<32px) variant changes only these.
  // eyeR 9, not 13: at r13 inside an r25 patch the black patch becomes a thin
  // annulus and the eyes read as goggles. r9 keeps the patch dominant and the
  // white a glint, which is the small-size identity.
  compact: { eyeR: 9, mouthStroke: 5 },
};

// Animation timings — printed on /animation, ported by hand.
export const TIMING = {
  blink: { duration: 140, easing: "ease-in-out", intervalMin: 3500, intervalMax: 7000, doubleChance: 1 / 6, doubleGap: 180, scaleY: 0.08 },
  breathe: { duration: 4000, easing: "ease-in-out", scale: 1.012 },
  twitch: { duration: 300, easing: "ease-in-out", intervalMin: 8000, intervalMax: 14000, angle: 5 },
  track: { maxOffset: 3, stiffness: 0.08, damping: 0.78 },
  greet: { duration: 420, easing: "cubic-bezier(.34,1.56,.64,1)", from: 0.94, earAngle: 4 },
  hover: { duration: 220, easing: "ease-out", angle: 2.5, earLag: 40 },
  minSize: 48,
  compactBelow: 32,
};
